import React from 'react'
import { Button, CircularProgress } from '@material-ui/core'

const ProgressButton = ({ label, inProgress, ...rest }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Button
        startIcon={
          inProgress && (
            <CircularProgress color="secondary" size={15} style={{ marginRight: '10px' }} />
          )
        }
        variant="contained"
        size="large"
        color="primary"
        {...rest}>
        {label}
      </Button>
    </div>
  )
}

export default ProgressButton
